<classic-report [report]="this.reportVariant" [reportName]="'JGW Learner Agreed Start Report'"
  [displayName]="'JGW+ Learner Agreed Start Report'" [defaultDisplayColumns]="this.defaultDisplayColumns"
  [dateFilterTypes]="this.dateFilters" [groupByColumns]="this.groupByColumns" [reportRefreshed]="true">
</classic-report>